export function createLatestLoader(fetchValue, onValue, onError) {
  let pending = null;

  function cancel() {
    const previous = pending;
    pending = null;
    previous?.controller.abort();
  }

  function load(id) {
    if (!id) return Promise.resolve();
    if (pending?.id === id) return pending.promise;
    cancel();
    const entry = { id, controller: new AbortController(), promise: null };
    pending = entry;
    entry.promise = Promise.resolve()
      .then(() => fetchValue(id, entry.controller.signal))
      .then((value) => {
        if (pending === entry && !entry.controller.signal.aborted) onValue(value);
      })
      .catch((error) => {
        if (pending === entry && !entry.controller.signal.aborted) onError(error);
      })
      .finally(() => {
        if (pending === entry) pending = null;
      });
    return entry.promise;
  }

  return { load, cancel };
}

export function startVisiblePolling(task, { interval = 5000, target = document, onError } = {}) {
  let stopped = false;
  let running = false;
  let timer;

  function schedule() {
    if (!stopped && !target.hidden) timer = setTimeout(poll, interval);
  }

  async function poll() {
    if (stopped || running || target.hidden) return;
    running = true;
    try { await task(); } catch (error) { onError?.(error); }
    finally {
      running = false;
      schedule();
    }
  }

  function visibilityChanged() {
    clearTimeout(timer);
    if (!target.hidden) void poll();
  }

  target.addEventListener("visibilitychange", visibilityChanged);
  schedule();
  return () => {
    stopped = true;
    clearTimeout(timer);
    target.removeEventListener("visibilitychange", visibilityChanged);
  };
}
